import { Component, ViewChild, Input, Output, EventEmitter } from "@angular/core";
import { GlobalsService, BusinessDevelopmentService } from "@services";
import { IBusinessDevelopmentAccountModel, IEmailerAddressModel, IEmailerSuggestedRecipientModel } from "@models";
import { NotesComponent } from "@components/notes";

@Component({
    selector: "business-development-notes",
    templateUrl: "business-development-notes.component.html",
    standalone: false
})
export class BusinessDevelopmentNotesComponent {
	@Input() businessDevelopmentAccountId: number;
	@Input() businessDevelopmentAccount: IBusinessDevelopmentAccountModel;
	@Output() onNoteAdded: EventEmitter<void> = new EventEmitter();

	@ViewChild("userNotes") userNotes: NotesComponent;
	@ViewChild("systemNotes") systemNotes: NotesComponent;

	userNotesUrl: string;
	addUserNotesUrl: string;
	toEmailAddresses: IEmailerAddressModel[];
	canViewUserNotes: boolean = GlobalsService.checkPermission("BusinessDevelopmentNotes", "View");
	canViewSystemNotes: boolean = GlobalsService.checkPermission("BusinessDevelopmentSystemNotes", "View");
	emailHeader: string;
	emailFooter: string;
	suggestedRecipients: IEmailerSuggestedRecipientModel[] = [];

	constructor(private businessDevelopmentService: BusinessDevelopmentService) { }

	refreshUserNotes() {
		this.userNotes.refreshNotes();
	}

	refreshSystemNotes() {
		this.systemNotes.refreshNotes();
	}

	ngOnInit() {
	}

	ngOnChanges() {
		this.userNotesUrl = `/businessDevelopment/getBusinessDevelopmentUserNotes?businessDevelopmentAccountId=${this.businessDevelopmentAccountId}`;
		this.addUserNotesUrl = `/businessDevelopment/addBusinessDevelopmentUserNotes?businessDevelopmentAccountId=${this.businessDevelopmentAccountId}`;
		this.toEmailAddresses = [];
		this.emailHeader = null;
		this.emailFooter = null;

		this.emailHeader = "<div style='font-size: 22px'>Account Name: " + this.businessDevelopmentAccount.contact.displayName + "</div>";
		this.emailHeader += "Sent by: " + GlobalsService.userInfo.fullName;

		this.suggestedRecipients = this.businessDevelopmentService.getBusinessDevelopmentRecipientSuggestions(this.businessDevelopmentAccount);
	}

	noteAdded() {
		if (this.onNoteAdded)
			this.onNoteAdded.emit();
	}
}
